import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.companyBillingAddress || initialState;

export const selectCompanyBillingAddreses = createSelector(
  [selectDomain],
  (state) => state.billingAddresses
);

export const selectCompanyDetails = createSelector(
  [selectDomain],
  (state) => state.companyDetails
);

export const selectCountries = createSelector(
  [selectDomain],
  (state) => state.countries
);

export const selectStates = createSelector(
  [selectDomain],
  (state) => state.states
);

export const selectCities = createSelector(
  [selectDomain],
  (state) => state.cities
);
export const selectTotalAddresses = createSelector(
  [selectDomain],
  (state) => state.totalAddresses
);
